/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/objectsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Objects. */
var Objects = /** @class */ (function () {
    /**
     * Create a Objects.
     * @param {GraphRbacManagementClientContext} client Reference to the service client.
     */
    function Objects(client) {
        this.client = client;
    }
    Objects.prototype.getObjectsByObjectIds = function (parameters, options, callback) {
        return this.client.sendOperationRequest({
            parameters: parameters,
            options: options
        }, getObjectsByObjectIdsOperationSpec, callback);
    };
    Objects.prototype.getObjectsByObjectIdsNext = function (nextLink, options, callback) {
        return this.client.sendOperationRequest({
            nextLink: nextLink,
            options: options
        }, getObjectsByObjectIdsNextOperationSpec, callback);
    };
    return Objects;
}());
export { Objects };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getObjectsByObjectIdsOperationSpec = {
    httpMethod: "POST",
    path: "{tenantID}/getObjectsByObjectIds",
    urlParameters: [
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    requestBody: {
        parameterPath: "parameters",
        mapper: __assign(__assign({}, Mappers.GetObjectsParameters), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryObjectListResult
        },
        default: {
            bodyMapper: Mappers.CloudError
        }
    },
    serializer: serializer
};
var getObjectsByObjectIdsNextOperationSpec = {
    httpMethod: "POST",
    path: "{tenantID}/{nextLink}",
    urlParameters: [
        Parameters.nextLink,
        Parameters.tenantID
    ],
    queryParameters: [
        Parameters.apiVersion
    ],
    headerParameters: [
        Parameters.acceptLanguage
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryObjectListResult
        },
        default: {
            bodyMapper: Mappers.CloudError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=objects.js.map